export const baseDev="";
export const baseProd="https://oa.goldenhighway.com/mdataserver";
export  const filerequesturl="https://oa.goldenhighway.com/mdataserver/masterData/saveExcel"
export  const filerequesturlPic="https://oa.goldenhighway.com/mdataserver/system/uploadFile"
export  const file_url='https://oa.goldenhighway.com'